import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

import { OrderControlTableContentViewModel } from './orderControlTableContentViewModel';
import { OrderControlHeaderKey, TableContentProperty } from '../../interface/tableContentHeaders';
import TableCell from '../TableCell.vue';
import RecommendTag from '@/corePagesModule/components/RecommendTag.vue';
import { TableContentItem } from '../../interface/tableContentItems';
import router from '@/router';
import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { IOrderControl } from '@/orderControlModule/entities/IOrderControl';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import { computed } from 'vue';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';

/**
 * 編集可能セルの種類
 */
type EditableCell = 'OrderNumber' | 'OrderRecommendCrossDate' | 'OrderRecommendAmount';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderControlTableCell',
  props: {
    header: {},
    orderControlHeaderKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isBold: { type: Boolean },
    isEditing: { type: Boolean },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["changeEditableValue", "onClickNarrow", "onCheckboxSelected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

const OrderControlTableContentVM = new OrderControlTableContentViewModel();
const t = i18n.t;

/**
 * ページ遷移を行う処理
 * TODO: 新IBusinessへの以降処理前でごちゃごちゃするのを避けるため、一旦旧IBusinessの型で置いている
 * 本当はstoreに括り出すべきでは？
 * @param event -  取引情報
 */
const sendPageMethod = (event: TableContentItem) => {
  const order = event as IOrderControl;
  // NOTE: 通常のBusinessIdの場合はSplitをする必要がないが、Arrivalから変換されたBusinessのIdの場合は、BusinessId-ArrivalIdの形式になっているため、'-'でSplitする'
  window.open(`#/business/recommend-order/${order ? order.aggregateBusinessId : undefined}`, '_blank');
};

const textAlign = computed(() => {
  if (props.header.key === 'OrderControlChoice') {
    return 'center';
  }
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

/**
 * 発注が推奨発注かつ、発注日が当日以前の場合、太字の赤色で表示する
 * @param header - ヘッダー情報
 * @param item - 発注情報
 */
const isRedAndBold = (header: string, item: TableContentItem) => {
  return (
    header === 'OrderControlOrderDate' && item.orderStatus === OrderStatus.Recommended && new Date(item.createdOrderDate) <= new Date()
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([[_unref(OrderControlTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(OrderControlTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    "text-align": textAlign.value,
    "table-content-property": _ctx.header,
    "tool-tip-value": _unref(OrderControlTableContentVM).displayOrderItem(_ctx.orderControlHeaderKey, _ctx.item),
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      (_ctx.orderControlHeaderKey === 'OrderConfirmation')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.item.virtualChild)
              ? (_openBlock(), _createBlock(TextButton, {
                  key: 0,
                  class: "detail-button",
                  "button-style": "btn-secondary",
                  "on-click": () => sendPageMethod(_ctx.item)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('詳細')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["on-click"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.orderControlHeaderKey === 'OrderControlOrderStatus')
        ? (_openBlock(), _createBlock(RecommendTag, {
            key: 1,
            status: _ctx.item.orderStatus
          }, null, 8, ["status"]))
        : (_ctx.orderControlHeaderKey === 'OrderControlChoice')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_ctx.isEditing && !_ctx.item.isVirtualChild)
                ? (_openBlock(), _createBlock(RowCheckBox, {
                    key: 0,
                    "is-checked": _ctx.isChecked,
                    class: "md-primary all-check-button",
                    onChangeStatus: _cache[0] || (_cache[0] = ($event: any) => (emits('onCheckboxSelected', _ctx.item?.displayId)))
                  }, null, 8, ["is-checked"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: _normalizeClass(["table-cell-content", {
          'table-cell-content--bold': _ctx.isBold || isRedAndBold(_ctx.orderControlHeaderKey, _ctx.item),
          'table-cell-content--red': isRedAndBold(_ctx.orderControlHeaderKey, _ctx.item),
        }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('onClickNarrow')))
            }, _toDisplayString(_unref(OrderControlTableContentVM).displayOrderItem(_ctx.orderControlHeaderKey, _ctx.item)), 3))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})